import React from 'react';
import { CONTACT_PAGE_URL, EXTRA_LINKS_URL } from '../../utils/Routes';

function BookNowCta() {
  return (
    <section className='grid pt-12'>
      <div className='grid gap-6 text-center px-6 sm:px-8 md:px-16 lg:px-24 lg:container lg:mx-auto'>
        <section className='grid justify-center'>
          <div>
            <p className='font-semibold text-lg lg:text-2xl'>
              Hire me for private sessions!
            </p>
          </div>{' '}
        </section>

        {/* Cta */}
        <section className='grid p-2 shadow-cardShadowBold shadow-colour4/80 w-fit mx-auto'>
          <div className='grid border2 border-solid bg-colour4 mx-auto p-0.5'>
            <div className='grid border-4 border-solid border-colour4 bg-colour1 px-6 py-4 lg:py-6 lg:px-12 font-titleFont'>
              <div className='grid justify-center gap-2 lg:gap-4 text-xl'>
                <a href={CONTACT_PAGE_URL} className=''>
                  🎥 Contact Me To Join In
                </a>
                <a href={EXTRA_LINKS_URL} className=''>
                  🖤 Send Tribute
                </a>
                <a href={EXTRA_LINKS_URL} className=''>
                  🔞 Join My Fansite
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default BookNowCta;
